module.exports = __webpack_public_path__ + "static/img/honor-swiper-1.540cdd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honor-swiper-1.png
// module id = Fcq4
// module chunks = 1